// extracted by mini-css-extract-plugin
export default {"card":"e0-z","carouselContainer":"f0-z","carouselContent":"g0-z"};